import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AgentModel} from "../../angular/models/agent.model";
import {AgentsService} from "../../services/agents-service.service";

export class AgentAvatarCtrl implements IController {

  agent: AgentModel;
  agentReference: any;
  hideStatus: boolean;
  isLarge: boolean;
  isMedium: boolean;
  doUpload: boolean;
  canDelete: boolean;
  onUpload: Function;
  onDelete: Function;

  constructor(private agentsService: AgentsService) {
  }

  $onInit() {
    if (_.isUndefined(this.doUpload)) {
      this.doUpload = false;
    }
  }

  onUploadClick = (result) => {
    const url = _.get(result, 'data.url');
    const agentToUpdate = angular.copy(this.agent);
    _.set(agentToUpdate, 'user.avatarUrl', url);

    this.agentsService.updateOne(this.agent.id, agentToUpdate)
      .then((updatedAgent: AgentModel) => {
        this.onUpload({agent: updatedAgent});
      })
  };

}

angular
  .module('bringoz.admin.agents')
  .component('agentAvatar', {
    bindings: {
      agent: '<?',
      agentReference: '<?',
      hideStatus: '<?',
      hideTaskCount: '<?',
      isLarge: '<?',
      isMedium: '<?',
      doUpload: '<?',
      canDelete: '<?',
      onUpload: '&',
      onDelete: '&'
    },
    template: require('./agent-avatar.html').default,
    controller: AgentAvatarCtrl
  });
